import { serviceColors } from "./constants";
import {
  compareFoundationFirst,
  isServiceCategoryHighlighted,
  resolveServiceBadgePresentation,
} from "./serviceCategoryBadgeDisplay";

/** Badge rows for chat / discovery vendor cards (Foundation first, catalog labels). */
export function buildVendorServiceCategoryBadgeRows(
  serviceCategories = [],
  highlightedServices = [],
  colors = serviceColors
) {
  return [...(serviceCategories || [])]
    .sort((a, b) => compareFoundationFirst(a, b))
    .map((category) => {
      const { displayName, color } = resolveServiceBadgePresentation(
        category,
        colors
      );
      return {
        category,
        displayName,
        color,
        isHighlighted: isServiceCategoryHighlighted(
          category,
          highlightedServices
        ),
      };
    });
}
